import { Component, input, signal } from '@angular/core';
import { BeforeAfter, SetupWizardPreviewStatus, SetupWizardSection, SetupWizardUser } from '@mira-avant/mtlibs';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';
import {
	BEFORE_AFTER_STATUS_CHANGED_COLOR,
	BEFORE_AFTER_STATUS_NEW_COLOR,
	BEFORE_AFTER_STATUS_UNCHANGED_COLOR,
	BEFORE_AFTER_STATUS_UPSERT_COLOR,
} from '../setup-wizard-before-after-status/setup-wizard-before-after-status';
import { Subscription } from 'rxjs/internal/Subscription';
import { SetupWizard } from '../../../../../../services/setup-wizard';
import { toObservable } from '@angular/core/rxjs-interop';
import { combineLatest, distinctUntilChanged } from 'rxjs';

@Component({
	selector: 'app-setup-wizard-before-after-status-with-enrollment',
	imports: [NzTagModule, NzTooltipModule],
	standalone: true,
	templateUrl: './setup-wizard-before-after-status-with-enrollment.html',
	styleUrl: './setup-wizard-before-after-status-with-enrollment.scss',
})
export class SetupWizardBeforeAfterStatusWithEnrollment<T> {
	upsertMode = input<boolean>(false);
	data = input.required<BeforeAfter<T>>();
	user = input<SetupWizardUser | null>(null);
	section = input<SetupWizardSection | null>(null);
	hasEnrollmentChanged = signal<boolean>(false);
	SetupWizardPreviewStatus = SetupWizardPreviewStatus;
	public BEFORE_AFTER_STATUS_UPSERT_COLOR = BEFORE_AFTER_STATUS_UPSERT_COLOR;
	public BEFORE_AFTER_STATUS_NEW_COLOR = BEFORE_AFTER_STATUS_NEW_COLOR;
	public BEFORE_AFTER_STATUS_CHANGED_COLOR = BEFORE_AFTER_STATUS_CHANGED_COLOR;
	public BEFORE_AFTER_STATUS_UNCHANGED_COLOR = BEFORE_AFTER_STATUS_UNCHANGED_COLOR;
	private sub?: Subscription;

	constructor(private setupWizard: SetupWizard) {
		const section$ = toObservable(this.section).pipe(distinctUntilChanged());
		const user$ = toObservable(this.user).pipe(distinctUntilChanged());

		this.sub = combineLatest([this.setupWizard.preview$, section$, user$]).subscribe(([preview, section, user]) => {
			if (!section && !user) {
				throw new Error('Either section or user must be provided');
			}

			if (section) {
				const hasChanged = this.setupWizard.hasSectionEnrollmentChanged(section);
				this.hasEnrollmentChanged.set(hasChanged);
			} else if (user) {
				const hasChanged = this.setupWizard.hasUserEnrollmentChanged(user);
				this.hasEnrollmentChanged.set(hasChanged);
			} else {
				this.hasEnrollmentChanged.set(false);
			}
		});
	}

	ngOnDestroy() {
		this.sub?.unsubscribe();
	}
}
